import { Empty, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getPayments } from "../service";
import { useSelector } from "react-redux";
import Moment from "react-moment";
import { convertUTCToLocalTime } from "../../../utils/service";
import NumberFormat from "react-number-format";
import Loader from "../../../shared/loader";
import AppAlert from "../../../shared/appAlert";
import AppTitle from "../../../shared/appTitle";
const { Title } = Typography;
const TransactionComponent = () => {
  const history = useHistory();
  const customerInfo = useSelector((store) => store.userConfig.userProfileInfo);
  const [recentTransactions, setRecentTransactions] = useState([]);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    getRecentTransactions();
  }, [])

  const getRecentTransactions = async () => {
    try {
      setLoader(true);
      let response = await getPayments('Merchant/transactions', customerInfo?.id);
      setRecentTransactions(response);
    }
    catch (errors) {
      setError(errors);
    }
    finally {
      setLoader(false);
    }
  }
  const handleOpen = (item) => {
    history.push(`/transactionDetails/${item?.id}/${item?.transactionType}`)
  }
  const handleRedirect = () => {
    history.push('/viewtransactions');
  };
  return (
    <div className="left-panel pannel-bg mb-leftpanel">
      {loader ? <Loader /> : ""}
      <div className='custom-flex'>
        <Title className='card-title ordrhstry-title '>Transactions</Title>
        <div onClick={handleRedirect}>
          <span className="text-link c-pointer view-more">View More</span> <span class="icon lg square-arrow c-pointer" ></span>
        </div></div>
      {error && (
        <div className="alert-flex" style={{ width: "100%" }}>
          <AppAlert
            className="w-100 "
            type="warning"
            description={error}
            showIcon
          />
          <span className="icon sm alert-close" onClick={() => setError(null)}></span>
        </div>
      )}
      
      <div className="payment-links">
      {(!recentTransactions || recentTransactions?.length === 0) && !loader && <div className="h-full d-flex align-items-center justify-center">
        <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="No Data"
      ></Empty>
        </div>}
        <table style={{width:"100%",minWidth:1250}} className="alltransactions-table">
        {recentTransactions?.length > 0 && recentTransactions.map((item, index) => (
          <tr key={index} className="custom-table card">
            <td className="" width={200}>
              <label htmlFor className="table-label">Transaction ID</label>
              <AppTitle level={4} className="table-text c-pointertransaction-id-text text-link c-pointer" onClick={() => handleOpen(item)}>{item?.txId}
              </AppTitle>
            </td>
            <td className="" width={230}>
                <label className="table-label">Date</label>
                <Title level={4} className="table-text text-white">
                  <Moment format="DD/MM/YYYY hh:mm:ss A">
                    {item?.transactionDate && convertUTCToLocalTime(item?.transactionDate)}
                  </Moment>
                </Title>
             </td>
           {/* <div className="">
              <label className="table-label">Merchant Account</label>
              <Title level={4} className="table-text">{item?.merchantName}</Title>
            </div> */}
            <td className="" width={160}>
              <label className="table-label">Transaction Type</label>
              <Title level={4} className="table-text">{item.transactionType}</Title>
            </td>
            <td className="">
              <label className="table-label">Value</label>
              <Title level={4} className="table-text">
                <NumberFormat value={item?.value} displayType="text" thousandSeparator={true} />
              </Title>
            </td>
            <td className="">
              <label className="table-label">Wallet</label>
              <Title level={4} className="table-text">
                {item.wallet}
              </Title>
            </td>
            <td className="">
              <label className="table-label">Network</label>
              <Title level={4} className="table-text">
                {item.network}
              </Title>
            </td>
            <td className="">
              <label className="table-label">Status</label>
              <Title level={4} className={`table-text ${item.status == 'Submitted' ? 'text-blue' : ''} ${item.status == 'Approved' ? 'text-green' : ''} `}>{item.status}</Title>
            </td>
          </tr>
        ))}
        </table>
      </div>
    </div>
  )
}
export default TransactionComponent
